import { useState } from "react";
import MDialog from "../../components/ui/atoms/MDialog";
import { MButton } from "../../components/ui/atoms/MButtons";

const ModalDialogTest = () => {
  const [basicModalOpen, setBasicModalOpen] = useState(false);
  const [singleActionModalOpen, setSingleActionModalOpen] = useState(false);
  const [destructiveModalOpen, setDestructiveModalOpen] = useState(false);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [loadingModalOpen, setLoadingModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const handleLoadingAction = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      setLoadingModalOpen(false);
    }, 2000);
  };

  return (
    <div className="p-8 bg-neutral-10 min-h-screen">
      <h1 className="text-2xl font-bold text-primary-indigo-600 mb-6">
        Modal Dialog Component Test
      </h1>

      <div className="flex flex-col gap-4 max-w-md">
        <MButton onClick={() => setBasicModalOpen(true)}>
          Open Modal with Two Actions
        </MButton>
        <MButton onClick={() => setSingleActionModalOpen(true)}>
          Open Modal with Single Action
        </MButton>
        <MButton onClick={() => setDestructiveModalOpen(true)}>
          Open Destructive Modal
        </MButton>
      </div>

      {/* Basic Modal with Two Actions */}
      <MDialog
        isOpen={basicModalOpen}
        onClose={() => setBasicModalOpen(false)}
        title="Heading"
        description="To get updates on WhatsApp, we need your mobile number linked to your profile."
        primaryCtaText="Done"
        onPrimaryCta={() => setBasicModalOpen(false)}
        secondaryCtaText="Cancel"
        onSecondaryCta={() => setBasicModalOpen(false)}
      ></MDialog>

      {/* Modal with Single Action */}
      <MDialog
        isOpen={singleActionModalOpen}
        onClose={() => setSingleActionModalOpen(false)}
        title="Notification"
        description="Your changes have been saved successfully."
        primaryCtaText="Done"
        onPrimaryCta={() => setSingleActionModalOpen(false)}
      ></MDialog>

      {/* Destructive Modal Example */}
      <MDialog
        isOpen={destructiveModalOpen}
        onClose={() => setDestructiveModalOpen(false)}
        title="Delete Item"
        description="Are you sure you want to delete this item? This action cannot be undone."
        primaryCtaText="Delete"
        onPrimaryCta={() => setDestructiveModalOpen(false)}
        secondaryCtaText="Cancel"
        onSecondaryCta={() => setDestructiveModalOpen(false)}
        destructivePrimary={true}
      ></MDialog>
    </div>
  );
};

export default ModalDialogTest;
